'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FilterSection } from './filter-section.component';

import { Slider } from '@/components/ui/slider/slider.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { distanceFilter } from '@/app/(main)/(pages)/busca/[slug]/_consts/distance-filter.const';

interface DistanceFilterSectionProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function DistanceFilterSection({ value, onChange, disabled = false }: DistanceFilterSectionProps) {
  return (
    <FilterSection label="Distância">
      <div
        className="flex flex-col gap-2"
        style={{ paddingTop: '3.3rem' }}
        data-testid={DataTestIdEnum.SEARCH_FILTERS_DISTANCE_SLIDER}
      >
        <Slider
          value={value}
          onChange={onChange}
          min={distanceFilter.min}
          max={distanceFilter.max}
          step={distanceFilter.step}
          unit={distanceFilter.unit}
          disabled={disabled}
          ariaLabel="Distância máxima"
        />
        <div className="flex items-center justify-between">
          <Typography as="span" variant={TypographyVariant.MEDIUM_BODY_TEXT} className="text-gray-500">
            {distanceFilter.minLabel}
          </Typography>
          <Typography as="span" variant={TypographyVariant.MEDIUM_BODY_TEXT} className="text-gray-500">
            {distanceFilter.maxLabel}
          </Typography>
        </div>
      </div>
    </FilterSection>
  );
}
